/*eslint new-cap:0 */
import ko from 'knockout';

export default class ViewModel {
  constructor(previewModel = {}) {
    const adViewModel = previewModel.adViewModel;

    this.Text = previewModel.Text;
    this.Title = previewModel.Title;
    this.DisplayUrl = previewModel.DisplayUrl;

    this.DestinationUrl = ko.computed(() => {
      let useFinalUrl = adViewModel.DevicePreference.isMobile() || !adViewModel.isFinal();

      return useFinalUrl ? adViewModel.url() : adViewModel.mobileUrl();
    });
  }
}
